
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 6C3.355 6 2 7.355 2 9v14c0 1.645 1.355 3 3 3h22c1.645 0 3-1.355 3-3V9c0-1.645-1.355-3-3-3zm0 2h22c.566 0 1 .434 1 1v14c0 .566-.434 1-1 1H5c-.566 0-1-.434-1-1V9c0-.566.434-1 1-1zm5.438 6.156c-.626 0-1.094.453-1.094 1.031 0 .485.23.727.875.97.375.14.687.222.687.562 0 .285-.222.5-.531.5a.805.805 0 01-.75-.469l-.469.406c.317.465.727.688 1.25.688.715 0 1.188-.473 1.188-1.157 0-.562-.219-.84-1-1.125-.414-.152-.531-.246-.531-.437 0-.223.203-.375.5-.375.207 0 .382.082.562.281l.375-.469a1.632 1.632 0 00-1.063-.406zm3.25 0c-1.043.004-1.876.817-1.876 1.844 0 1.035.829 1.844 1.876 1.844.296 0 .562-.07.874-.219v-.813c-.273.274-.53.375-.843.375-.692 0-1.188-.503-1.188-1.218 0-.676.512-1.188 1.156-1.188.329 0 .59.094.876.375v-.812c-.301-.153-.579-.188-.876-.188zm2.906 0A1.847 1.847 0 0014.75 16c0 1.016.828 1.844 1.844 1.844A1.847 1.847 0 0018.437 16a1.847 1.847 0 00-1.843-1.844zM5 14.22v3.531h1c1.535 0 1.906-1.2 1.906-1.75 0-1.04-.789-1.781-1.906-1.781zm3.219 0v3.531h.687V14.22zm10.094 0l1.5 3.625h.375l1.53-3.625h-.75L20 16.594l-.938-2.375zm3.718 0v3.531h1.938v-.594h-1.25v-.968h1.218v-.594H22.72v-.781h1.25v-.594zm2.407 0v3.531h.687v-1.406h.063l.968 1.406H27l-1.125-1.5c.52-.105.813-.46.813-1 0-.66-.458-1.031-1.25-1.031zm.687.562h.188c.43 0 .687.188.687.531 0 .356-.246.532-.688.532h-.187zm-19.438.031h.22c.937 0 1.28.633 1.28 1.188 0 .266-.074 1.156-1.312 1.156h-.188z","fill":"#5b5b5b"}})])
          )
        }
      }
    